import React, {Component} from 'react'
import API_Root from "../../Constants/API_Root";
import Loader from 'react-loader-spinner'
import isObjectEmpty from "../../Constants/isObjectEmpty";
import { Button, Icon } from 'semantic-ui-react'
import GoogleAccountRow from "./GoogleAccountRow";
import ProfileDisplayHeader from "../../InfoPages/Profile/ProfileDisplayHeader"
import AccountsErrorBanner from "../../InfoPages/Profile/AccountsErrorBanner";
import AccountsNotConnectedBanner from "../../InfoPages/Profile/AccountsNotConnectedBanner";

class GoogleAccountsIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            accountInfo: null,
            fetching: true,
            error: false
        }
    }

    componentDidMount(){
        const hitError = () => this.setState({ fetching: false, error: true, accountInfo: null })

        fetch(API_Root + 'api/get-google-connected-accounts-info/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
            },
            body: JSON.stringify({
                email: localStorage.getItem("email"),
                token: localStorage.getItem("token")
            })
        }).then(res => {
            if (res.status === 200){
                res.json().then((data) => {
                        this.setState({ accountInfo: data, fetching: false, error: false })
                    }).catch(err => hitError())
            }
            else{
                hitError()
            }
        }).catch(err => hitError());
    }

    render() {
        if (this.state.fetching){
            return (
                <Loader
                    type="TailSpin"
                    color="black"
                    height="40"
                    width="40"
                />
            )
        } else {
            if (this.state.error){
                return (
                    <AccountsErrorBanner
                        accountType="Google"
                    />
                )

            } else {
                if (this.state.accountInfo === null){
                    return (
                        <AccountsNotConnectedBanner
                            accountType="Google"
                        />
                    )
                } else {
                    if (isObjectEmpty(this.state.accountInfo)){
                        return (
                            <AccountsNotConnectedBanner
                                accountType="Google"
                            />
                        )
                    } else {
                        let googleRows = [];

                        for (let email in this.state.accountInfo){
                            const info = this.state.accountInfo[email];

                            googleRows.push(<GoogleAccountRow
                                key={email}
                                email={email}
                                isRefreshToken={info.isRefreshToken}
                                hasGooglePermissions={info.hasGooglePermissions}
                                name={info.name}
                                profilePic={info.profilePic}
                            />)
                        }

                        return (
                            <div>
                                {googleRows}
                            </div>
                        )
                    }
                }
            }

        }
    }
}

export default GoogleAccountsIndex